import { render, staticRenderFns } from "./PDvBorderBox10.vue?vue&type=template&id=2ab1b312&scoped=true&"
import script from "./PDvBorderBox10.vue?vue&type=script&lang=js&"
export * from "./PDvBorderBox10.vue?vue&type=script&lang=js&"
import style0 from "./PDvBorderBox10.vue?vue&type=style&index=0&id=2ab1b312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1b312",
  null
  
)

export default component.exports